'use client';
import { Link } from '@web/ui/base/Link/Link';
import ExclamationTriangle from '@web/ui/icons/exclamation_triangle.svg';
import { translate } from '@web/helpers/localization';
import { useEffect } from 'react';

export default function Error({
	error,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<div className="flex flex-col flex-initial justify-center content-center h-screen max-w-3xl mx-auto text-center">
			<ExclamationTriangle alt="Not found icon" className="w-20 mb-4 mx-auto" />
			<h1>{translate('pages.500.page_title')}</h1>
			<Link href="/" className="btn btn-primary mx-auto w-fit">
				{translate('shared.errors.back_to_homepage')}
			</Link>
		</div>
	);
}
